import script from "./PackageShablone.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageShablone.vue?vue&type=script&setup=true&lang=js"

import "./PackageShablone.vue?vue&type=style&index=0&id=4e7c5bca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e7c5bca"]])

export default __exports__